import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATEGORY_LABELS } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { ComingSoon } from "../components/ComingSoon";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "pokemon", label: "Pokémon" },
  { key: "sports", label: "Sports" },
  { key: "graded", label: "Graded" },
  { key: "sealed", label: "Sealed" },
];

export default function Products() {
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: active === "all" ? {} : { category: active } })
      .then(({ data }) => setProducts(data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [active]);

  const setCategory = (key) => {
    if (key === "all") setParams({});
    else setParams({ category: key });
  };

  return (
    <div data-testid="products-page">
      <div className="bg-[#262626] text-[#F9F6F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#D32F2F]">The Shop</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-black tracking-tighter">
            {active === "all" ? "All Cards" : CATEGORY_LABELS[active]}
          </h1>
          <p className="mt-3 text-[#F9F6F0]/70 max-w-xl">
            Pokémon, sports, graded slabs and sealed product — hand-picked for collectors of all ages.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10">
        <div className="flex flex-wrap gap-3 mb-10">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setCategory(f.key)}
              data-testid={`filter-${f.key}`}
              className={`px-5 py-2.5 rounded-full text-sm font-bold uppercase tracking-wide transition-colors ${
                active === f.key
                  ? "bg-[#D32F2F] text-white"
                  : "bg-white border border-[#262626]/15 text-[#262626] hover:border-[#D32F2F] hover:text-[#D32F2F]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="bg-white rounded-lg border border-[#262626]/10 p-4 animate-pulse">
                <div className="aspect-square bg-[#F9F6F0] rounded-md mb-4" />
                <div className="h-4 bg-[#F9F6F0] rounded mb-2" />
                <div className="h-4 bg-[#F9F6F0] rounded w-1/2" />
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <p className="text-center text-[#262626]/60 py-20">No products in this category yet. Check back soon!</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="products-grid">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>

      {active === "pokemon" && <ComingSoon variant="light" />}
    </div>
  );
}
